import { IPostsResponse, IUpdateSpamPostModerationStatusRequest } from 'types/posts'
import { IAction, IError } from 'types/redux'

export const GET_SPAM_POSTS_REQUEST = 'GET_SPAM_POSTS_REQUEST'
export const GET_SPAM_POSTS_SUCCESS = 'GET_SPAM_POSTS_SUCCESS'
export const GET_SPAM_POSTS_ERROR = 'GET_SPAM_POSTS_ERROR'

export const UPDATE_SPAM_POST_STATUS_REQUEST = 'UPDATE_SPAM_POST_STATUS_REQUEST'
export const UPDATE_SPAM_POST_STATUS_SUCCESS = 'UPDATE_SPAM_POST_STATUS_SUCCESS'
export const UPDATE_SPAM_POST_STATUS_ERROR = 'UPDATE_SPAM_POST_STATUS_ERROR'

export const getSpamPostsRequest = (data: number, token?: string): IAction => ({
  type: GET_SPAM_POSTS_REQUEST,
  data,
  token
})

export const getSpamPostsSuccess = (data: IPostsResponse): IAction => ({
  type: GET_SPAM_POSTS_SUCCESS,
  data
})

export const getSpamPostsError = (error: IError): IAction => ({
  type: GET_SPAM_POSTS_ERROR,
  error
})

export const updateSpamPostStatusRequest = (data: IUpdateSpamPostModerationStatusRequest): IAction => ({
  type: UPDATE_SPAM_POST_STATUS_REQUEST,
  data
})

export const updateSpamPostStatusSuccess = (data: unknown): IAction => ({
  type: UPDATE_SPAM_POST_STATUS_SUCCESS,
  data
})

export const updateSpamPostStatusError = (error: IError): IAction => ({
  type: UPDATE_SPAM_POST_STATUS_ERROR,
  error
})
